import React, { FC, useState } from 'react';
import '../../modals/restricted-modal/restricted_modal.scss';
import { setWantToBeContacted } from '../lawyer.api';
import { VerifyLawyerModalFirstStep } from './steps/VerifyLawyerModalFirstStep';
import { VerifyLawyerModalValidated } from './steps/VerifyLawyerModalValidated';

type Props = {
  lawyerName: string;
  lawyerId: string;
  closeModal: () => void;
  isOpen: boolean;
};

export const VerifyLawyerModal: FC<Props> = ({
  lawyerName,
  closeModal = () => {},
  isOpen = false,
  lawyerId,
}) => {
  const [askToVerify, setAskToVerify] = useState(false);

  const handleClick = async () => {
    await setWantToBeContacted(lawyerId);
    setAskToVerify(true);
  };

  if (!askToVerify) {
    return (
      <VerifyLawyerModalFirstStep
        closeModal={closeModal}
        isOpen={isOpen}
        handleClick={handleClick}
        lawyerName={lawyerName}
      />
    );
  }
  return <VerifyLawyerModalValidated closeModal={closeModal} isOpen={isOpen} />;
};
